var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"elevation-2",attrs:{"headers":_vm.headers,"items":_vm.items,"items-per-page":20,"locale":"pt-BR","no-data-text":"Nenhum dado encontrado","footer-props":{
    'items-per-page-text': 'Itens por página:',
    'items-per-page-options': [20, 50, 100],
    'show-first-last-page': true,
    'show-current-page': true,
  }}})
}
var staticRenderFns = []

export { render, staticRenderFns }